import axios from "axios";
import FormData from "form-data";

import type { Chatbot } from "@virtual-brain-lib/types";

import env from "../environments";
import { queryOptions } from "../query-client";

export async function createChatbot(props: { brainId: string; chatbotName: string }) {
	const response = await axios.post<Chatbot>(`${env.apiUrl}/chatbots/create`, {
		...props,
	});

	return response.data;
}

export async function getChatbot(id: string) {
	const response = await axios.get<Chatbot>(`${env.apiUrl}/chatbots/${id}`);

	return response.data;
}

export const getChatbotPreviewUrl = queryOptions({
	async queryFn({ queryKey }) {
		const [, { chatbotId }] = queryKey;
		const response = await axios.get<string>(`${env.apiUrl}/chatbots/preview/${chatbotId}`);

		return response.data;
	},
	queryKey: "chatbotPreview",
});

export async function updateChatbot({
	chatbot,
}: {
	chatbot: Partial<Omit<Chatbot, "visibility">> & { id: string };
}) {
	const response = await axios.put<Chatbot>(`${env.apiUrl}/chatbots/${chatbot.id}`, chatbot);

	return response.data;
}

export async function updateChatbotVisibility({
	chatbot,
}: {
	chatbot: Partial<Chatbot> & { id: string; visibility: string };
}) {
	const response = await axios.put<Chatbot>(`${env.apiUrl}/chatbots/${chatbot.id}`, chatbot);

	return response.data;
}

export async function uploadChatbotImage({
	chatbotId,
	fileType,
	file,
}: {
	chatbotId: string;
	fileType: string;
	file: Blob;
}) {
	const formData = new FormData();

	formData.append("file", file);
	formData.append("fileType", fileType);

	const response = await axios.post<Chatbot>(
		`${env.apiUrl}/chatbots/${chatbotId}/upload`,
		formData,
		{
			headers: {
				// eslint-disable-next-line @typescript-eslint/naming-convention
				"Content-Type": "multipart/form-data",
			},
		},
	);

	return response.data;
}

export async function deleteChatbotFile({
	chatbotId,
	fileType,
}: {
	chatbotId: string;
	fileType: "chatIcon" | "profilePicture";
}) {
	const response = await axios.put<Chatbot>(`${env.apiUrl}/chatbots/${chatbotId}/deleteFile`, {
		fileType,
	});

	return response.data;
}
